export default __webpack_public_path__ + "static/media/bang-cap-11_05.0b325fe5.jpg";